/**
 * This is the list of all features in this product. Every meaningful feature should be listed here adn have its proper
 * configuration at featuresConfig.
 */
export enum FeatureTypes {
  POST_TEXT_IMAGE_VIDEO_LINK = 'POST_TEXT_IMAGE_VIDEO_LINK',
  TIME_TARGET = 'TIME_TARGET',
}
